'use strict';

var analyticsHelper = require('app_honda_cars/utils/analyticsHelper');

/**
 * Initialise session tracking (timeSpent + pageNumber utilities)
 * and push the initial page_view event to the dataLayer.
 */
function init() {
    var currentPageNumber = analyticsHelper.initPageTracking();

    (function () {
        var path = window.location.pathname;
        var slug = path.split('/').pop().split('.')[0].toLowerCase();
        var pageType = 'static page'; // default
        if (path.indexOf('/configurator/') !== -1 || slug.indexOf('configurator') !== -1) {
            pageType = 'configurator page';
        } else if (path.indexOf('/search') !== -1 || path.indexOf('Search-Show') !== -1) {
            pageType = 'search page';
        } else if (path.split('/')[path.split('/').length-1] === 'cars' || slug.indexOf('cars') !== -1) {
            pageType = 'home page';
        } else if ($('.page .showroom').attr('id') === slug || $('.page.page--pdp_showroom')) {
            pageType = 'product explore page';
        } else if (path.split('/')[path.split('/').length-1] === 'checkout' || slug.indexOf('checkout') !== -1) {
            pageType = 'checkout page';
        }
        var gtmUserData = window._gtmUserData || {};
        window.dataLayer = window.dataLayer || [];
        var pageViewPayload = {
            event: 'page_view',
            pageType: pageType,
            timeSpent: analyticsHelper.getTimeSpent(),
            status: gtmUserData.status || 'Guest',
            pageNumber: currentPageNumber,
            timestamp_unix: Math.floor(Date.now() / 1000)
        };

        if (gtmUserData.userId) {
            analyticsHelper.sha256(gtmUserData.userId).then(function (hashedId) {
                pageViewPayload.user_id = hashedId;
                pageViewPayload.userId = hashedId;
            });
        }

        window.dataLayer.push(pageViewPayload);

    }());
}

module.exports = { init: init };
